export type CodecResult = { ok: true; value: string } | { ok: false; error: string };

export function encodeUrl(input: string, wholeUrl: boolean): CodecResult {
  try {
    return { ok: true, value: wholeUrl ? encodeURI(input) : encodeURIComponent(input) };
  } catch {
    return { ok: false, error: "This text has a broken character (an unpaired emoji or symbol half) that cannot be encoded." };
  }
}

/** Finds the first malformed percent-escape ("%" not followed by two hex digits), or null. */
export function findBadEscape(s: string): { index: number; snippet: string } | null {
  const m = /%(?![0-9a-fA-F]{2})/.exec(s);
  return m ? { index: m.index, snippet: s.slice(m.index, m.index + 3) } : null;
}

export function decodeUrl(input: string, wholeUrl: boolean, plusAsSpace: boolean): CodecResult {
  const bad = findBadEscape(input);
  if (bad) return { ok: false, error: `Malformed escape "${bad.snippet}" at position ${bad.index + 1}: a % must be followed by two hex digits (for example %20). Encode the literal % as %25.` };
  try {
    const src = plusAsSpace ? input.replace(/\+/g, " ") : input;
    return { ok: true, value: wholeUrl ? decodeURI(src) : decodeURIComponent(src) };
  } catch {
    return { ok: false, error: "These escapes do not form valid UTF-8 text (for example a lone %E2 or %C3). Check that the whole sequence was copied." };
  }
}
